export enum EIntraUsersPage {
  list = 'list',
  add  = 'add',
  edit = 'edit',
}
